var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8136 15.6639C10.3643 15.6639 10 15.3667 10 15L10 8.94026C10 8.57158 10.3664 8.27273 10.818 8.27273C11.27 8.27273 11.6364 8.57158 11.6364 8.94026V15C11.6364 15.1774 11.5493 15.3472 11.395 15.4721C11.2404 15.5968 11.0309 15.6658 10.8136 15.6639Z",
    fill: "#96A8BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6364 5.81818C11.6364 6.27003 11.27 6.63636 10.8182 6.63636C10.3663 6.63636 10 6.27004 10 5.81818C10 5.36632 10.3663 5 10.8182 5C11.27 5 11.6364 5.36632 11.6364 5.81818Z",
    fill: "#96A8BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1C8.34785 1 5.80423 2.05356 3.92909 3.92909C2.05364 5.80423 1 8.34785 1 11C1 13.6522 2.05356 16.1958 3.92909 18.0709C5.80423 19.9464 8.34785 21 11 21C13.6522 21 16.1958 19.9464 18.0709 18.0709C19.9464 16.1958 21 13.6522 21 11C21 8.34785 19.9464 5.80423 18.0709 3.92909C16.1958 2.05364 13.6522 1 11 1ZM11 19.2607C8.8091 19.2607 6.70803 18.3906 5.1589 16.8412C3.60945 15.292 2.73935 13.1909 2.73935 11.0001C2.73935 8.80926 3.60945 6.70811 5.1589 5.15898C6.70803 3.60953 8.80918 2.73943 11 2.73943C13.1908 2.73943 15.292 3.60953 16.8411 5.15898C18.3906 6.70811 19.2607 8.80926 19.2607 11.0001C19.2607 13.1909 18.3906 15.292 16.8411 16.8412C15.292 18.3906 13.1908 19.2607 11 19.2607Z",
    fill: "#96A8BA",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.2b6d65837c2ede73acd7c474ef41f6b9.svg";
export { ForwardRef as ReactComponent };